import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Card_module from "./Card.module.js";
import { FlexBox } from "../flexBox/FlexBox.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import { Text } from "../text/Text.js";
import { Separator } from "../separator/Separator.js";
import { InternalFlexBox } from "../flexBox/internal/InternalFlexBox.js";
var Card_CardIconPosition = /*#__PURE__*/ function(CardIconPosition) {
    CardIconPosition[CardIconPosition["Left"] = 0] = "Left";
    CardIconPosition[CardIconPosition["Top"] = 1] = "Top";
    return CardIconPosition;
}({});
var Card_CardSize = /*#__PURE__*/ function(CardSize) {
    CardSize["Small"] = "small";
    CardSize["Medium"] = "medium";
    return CardSize;
}({});
const Card = ({ title, titleTextProps, subtitle, size = "medium", icon: Icon, iconColor = 'gray-900', iconSize = 'normal', iconPosition = 0, illustration: Illustration, children, className, style, onClick, ...flexBoxProps })=>{
    const showIllustration = null != Illustration || null != Icon && 1 === iconPosition;
    const [animateIllustration, setAnimateIllustration] = useState(false);
    const as = onClick ? 'button' : 'div';
    return /*#__PURE__*/ jsxs(InternalFlexBox, {
        as: as,
        flexDirection: "column",
        className: combineClasses(Card_module.card, onClick && Card_module.clickable, className),
        style: style,
        ...flexBoxProps,
        onClick: onClick,
        onMouseEnter: ()=>setAnimateIllustration(true),
        onMouseLeave: ()=>setAnimateIllustration(false),
        children: [
            showIllustration && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(FlexBox, {
                        minHeight: 80,
                        alignItems: "center",
                        justifyContent: "center",
                        children: Illustration ? /*#__PURE__*/ jsx(Illustration, {
                            testId: Illustration.name,
                            animate: animateIllustration
                        }) : Icon && /*#__PURE__*/ jsx(Icon, {
                            testId: Icon.displayName ?? Icon.name,
                            color: iconColor,
                            style: {
                                width: 42,
                                height: 42
                            }
                        })
                    }),
                    /*#__PURE__*/ jsx(Separator, {})
                ]
            }),
            /*#__PURE__*/ jsxs(FlexBox, {
                flexDirection: "column",
                flexGrow: 1,
                className: combineClasses(Card_module.body, Card_module[size]),
                children: [
                    /*#__PURE__*/ jsxs(FlexBox, {
                        alignItems: "center",
                        children: [
                            Icon && 0 === iconPosition && /*#__PURE__*/ jsx(FlexBox, {
                                style: {
                                    marginRight: 12
                                },
                                children: /*#__PURE__*/ jsx(Icon, {
                                    size: iconSize,
                                    color: iconColor,
                                    testId: Icon.displayName ?? Icon.name
                                })
                            }),
                            /*#__PURE__*/ jsxs(FlexBox, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ jsx(Text, {
                                        as: "h3",
                                        size: "200",
                                        ...titleTextProps,
                                        children: title
                                    }),
                                    subtitle && /*#__PURE__*/ jsx(Text, {
                                        as: "p",
                                        color: "gray-800",
                                        size: "100",
                                        className: Card_module.subtitle,
                                        children: subtitle
                                    })
                                ]
                            })
                        ]
                    }),
                    children && /*#__PURE__*/ jsx(FlexBox, {
                        flexGrow: 1,
                        className: Card_module.content,
                        children: children
                    })
                ]
            })
        ]
    });
};
export { Card, Card_CardIconPosition as CardIconPosition, Card_CardSize as CardSize };
